<template>
  <div class="maintenance-window">
    <div class="maintenance-message">
      <h2>🛑 Temporarily unavailable</h2>
      <p>try again later.</p>
      <button @click="goBack" class="back-button">Back</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showMaintenance: true, // Controla si se muestra la ventana
      username: this.$route.query.username || "Unknown User", // Obtener el parámetro de la URL
    };
  },
  methods: {
    goBack() {
      // Recarga la página para volver a intentar
     this.$router.push({ name: 'DepositWebsiteLesotho' , query: { username: this.$route.query.username }  });
      // O podrías redireccionar a otra página:
      // this.$router.push('/home');
    }
  }
};
</script>

<style scoped>
.maintenance-window {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.maintenance-message {
  background-color: #fff;
  padding: 40px;
  border-radius: 8px;
  text-align: center;
}

.maintenance-message h2 {
  color: #ff8800;
}

.maintenance-message p {
  color: #333;
}

.back-button {
  margin-top: 20px;
  background-color: #ff8800;
  color: #fff;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
}

.back-button:hover {
  background-color: #cc6b00;
}
</style>
